import React from 'react';

const Notice = ({ children }) => {
    return (
        <div className="notice">
            <p className="not_title mb-1"> 注意事項</p>
            <ul>{children}</ul>
        </div>
    );
};

export default Notice;
